"use client";

import React from "react";
import { Check, Settings, Droplets, ArrowRight, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function VorteileSysteme() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const benefits = ["Tiefenreinigung bis in die Rillen", "Sofortige Absaugung – kein Durchtropfen in den Schacht", "Sauberer Einsatzbereich – kein Schmutz rundum", "Materialschonend – schützt Beschichtung und Mechanik", "Ohne Demontage & ohne Eingriff in die Steuerung", "Herstellerempfohlen & unbedenklich eingestuft"];
  return <section id="vorteile-systeme" ref={sectionRef} className="bg-background pt-6 pb-12 relative overflow-hidden">
      <div className="container px-4 max-w-6xl ![margin:2px_54.9729px_2px_54.9729px] md:px-6">
        {}
        <div className={cn("mb-24 transition-all duration-700 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          

          
        </div>

        <Separator className="my-16 opacity-50" />

        {}
        <div className="space-y-12">
          <div className={cn("transition-all duration-700 delay-200 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground mb-12 text-center">Unser Reinigungssystem im Vergleich</h2>

            {}
            

            {}
            <Card className="border-l-4 border-l-accent overflow-hidden hover:shadow-lg transition-shadow duration-300">
              <div className="grid md:grid-cols-[1fr_2fr] gap-6">
                <div className="bg-muted/30 p-8 flex flex-col justify-center items-center text-center border-b md:border-b-0 md:border-r border-border">
                  <div className="size-16 rounded-2xl bg-accent/10 flex items-center justify-center mb-4 text-amber-600 dark:text-accent">
                    <Settings className="size-8" />
                  </div>
                  <h3 className="text-xl font-bold text-foreground">Columbus-Junker System</h3>
                  <span className="text-sm text-muted-foreground mt-2">ROTOFAST 500 &amp; ROTOMAC 300</span>
                </div>
                <CardContent className="p-8 flex flex-col justify-center">
                  <div className="mb-6 p-4 bg-primary/5 rounded-lg border border-primary/10">
                    <p className="text-lg font-medium italic text-foreground flex gap-3">"Herstellerempfohlenes Reinigungsverfahren mit Tiefenreinigung, sofortiger Absaugung und materialschonendem Ergebnis."</p>
                  </div>
                  <ul className="grid sm:grid-cols-2 gap-4">
                    {["Tiefenreinigung bis in die Rillen", "Kein Durchtropfen in den Schacht", "Materialschonend für Beschichtung & Mechanik", "Ohne Demontage & ohne Eingriff in die Steuerung"].map((item, idx) => <li key={idx} data-index={idx} className="flex items-center gap-3 text-muted-foreground">
                        <Check className="size-4 text-primary/60" />
                        {item}
                      </li>)}
                  </ul>
                </CardContent>
              </div>
            </Card>
          </div>

          {}
          
        </div>
      </div>
    </section>;
}